import CacheUtil from "../../../../../shared/lib/html5-software-library/src/ranj/util/CacheUtil";
import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {

    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;
        this._scoreTextfield = this._target.scoreTextfield;
        this._mistakesTextfield = this._target.mistakesTextfield;
        this._timeTextfield = this._target.timeTextfield;

        this._target.mistakesLabelTextfield.lineWidth = null;
        this._target.scoreLabelTextfield.lineWidth = null;
        this._target.timeLabelTextfield.lineWidth = null;

        this._target.mistakesLabelTextfield.text = this.getText("hud.mistakesLabel");
        this._target.scoreLabelTextfield.text = this.getText("hud.scoreLabel");
        this._target.timeLabelTextfield.text = this.getText("hud.timeLabel");
        this._target.practiceIndicator.textfield.text = this.getText("hud.practiceIndicator");
        
        CacheUtil.cache(this._target.mistakesLabelTextfield);
        CacheUtil.cache(this._target.scoreLabelTextfield);
        CacheUtil.cache(this._target.timeLabelTextfield);

        this.practiceIndicatorOrigY = this._target.y;
        this.practiceIndicatorWithoutPracticeIndicatorY = this._target.y - (this._target.hudBackground.y - this._target.practiceIndicator.y);        
        this.showPracticeIndicator(false, true);
    }

    showPracticeIndicator(bool, instant = false) {
        var targetAlpha = bool ? 1 : 0;
        var targetY = bool ? this.practiceIndicatorOrigY : this.practiceIndicatorWithoutPracticeIndicatorY;

        if (instant) {
            this._target.practiceIndicator.alpha = targetAlpha;
            this._target.y = targetY;
            return;
        } else {
            createjs.Tween.get(this._target.practiceIndicator).to({ alpha: targetAlpha }, 500, createjs.Ease.quadOut);
            createjs.Tween.get(this._target).to({ y: targetY }, 500, createjs.Ease.quadOut);
        }
    }

    showPracticeTime() {
        this._timeTextfield.text = this.getText("hud.timePractice");
    }

    /**
     * @param {Number} value - remaining time in msecs
     */
    setTime(value) {
        value = Math.max(value, 0);
        const secs = Math.floor(value / 1000) % 60;
        const mins = Math.floor(value / 60000) % 60;
        const hours = Math.floor(value / 3600000) % 24;
        let str = padTime(mins) + ":" + padTime(secs);
        if (hours > 0) {
            str = hours + ":" + str;
        }
        this._timeTextfield.text = str;
    }

    setMistakes(n) {
        this._mistakesTextfield.text = n;
        if (n - this._mistakeCountLast == 1) {
            this._animateText(this._mistakesTextfield);
        }
        this._mistakeCountLast = n;
    }

    setScore(n) {
        this._scoreTextfield.text = n;
        if (n - this._scoreCountLast == 1) {
            this._animateText(this._scoreTextfield);
        }
        this._scoreCountLast = n;
    }

    _animateText(tf) {
        const s = 2, d = 150, dy = -4 * s;
        if (tf.yOrig == null) {
            tf.yOrig = tf.y;
        }
        tf.scaleX = tf.scaleY = 1;
        tf.y = tf.yOrig;
        CacheUtil.cache(tf, undefined, undefined, undefined, undefined, 3);
        createjs.Tween.get(tf)
            .to({ scaleX: s, scaleY: s, y: tf.yOrig + dy }, d, createjs.Ease.linear)
            .to({ scaleX: 1, scaleY: 1, y: tf.yOrig }, d, createjs.Ease.linear)
            .call(_ => { CacheUtil.uncache(tf); });
    }
}


function padTime(str) {
    return ("0" + str).substr(-2);
}